<template>
  <section class="completion-container">
    <div v-if="pageType === 'single'" class="left title">
      <span class="isRequred" v-if="isRequired">*</span>
      <span v-if="isShowNumber == 1">{{ qNo }}</span>
    </div>

    <div class="right">
      <div class="title" v-if="question.subject_title_type == 1">
        <div class="pure-text">{{ question.subject }}</div>
      </div>
      <div v-else><rich-text :type="2" :content="question.subject" /></div>
      <div class="answer-list">
        <section class="inputcomps">
          <input
            :class="[{ error: isError }, { focus: isFocus }]"
            placeholder="请输入你的手机号码"
            maxlength="11"
            v-model.number="phone"
            autocomplete="on"
            @focus="handleFocus"
            @blur="handleBlur"
            @input="handleInput"
          />
          <div class="errtips" v-if="isError">请输入正确的手机号</div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import RichText from '@/components/rich-text';

/**
 * 填手机号
 */
const phoneReg = /^1[3-9]\d{9}$/;

export default {
  name: 'Telphone',
  components: { RichText },
  props: {
    isShowNumber: {
      //是否显示序号
      type: Number,
      default: 0,
    },
    pageType: {
      type: String,
      default: 'single', // 默认单页展示
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    question: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number, // 当前问题在问题列表中的索引
      default: 0,
    },
    titleNo: {
      type: Number, // 当前题目序号
      default: 0,
    },
  },
  data() {
    return {
      qNo: this.titleNo < 9 ? `0${this.titleNo}` : this.titleNo, // 问题序号
      phone: '',
      isFocus: false,
      isError: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleFocus() {
      this.isFocus = true;
    },
    handleBlur() {
      console.log('handleblur');
      this.isFocus = false;
      if (!phoneReg.test(this.phone)) {
        this.isError = true;
      }
      if (!this.phone && !this.isRequired) {
        this.isError = false;
      }
    },
    handleInput() {
      if (phoneReg.test(this.phone)) {
        this.isError = false;
      } else {
        this.isError = true;
      }
      // 非必填情况：如果输入框为空，则不校验
      if (!this.phone && !this.isRequired) {
        this.isError = false;
      }
      this.$emit('change', this.phone, this.index, this.question);
    },
  },
};
</script>

<style lang="less" scoped>
.completion-container {
  display: flex;
  .isRequred {
    color: #ff3b30;
    font-size: 18px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 25px;
  }
  .left {
    width: 30px;
    margin-right: 8px;
    text-align: right;
  }
  .right {
    flex: 1;
    .answer-list {
      margin-top: 20px;
      width: 100%;
      .inputcomps {
        input {
          width: 100%;
          padding-left: 10px;
          box-sizing: border-box;
          height: 44px;
          border-radius: 4px;
          border: 1px solid rgba(0, 0, 0, 0.09);
          &.focus {
            border: 1px solid #ff6600;
          }
          &.error {
            border: 1px solid #ff3b30;
          }
        }
        .errtips {
          font-size: 14px;
          font-weight: 400;
          color: #ff3b30;
          line-height: 25px;
          margin-top: 4px;
        }
      }
    }
  }
}
</style>
